import { ModalBasic } from 'shared/Modal';
import { FC } from 'react';
import { Box, Button, Flex, SxStyleProp, Text } from 'theme-ui';
import { useTranslator } from '@picsart/rc/services/localization';

type FilesAreUploadingModalProps = {
  isOpen: boolean;
  closeHandler: () => void;
};

const modalContainerStyles: SxStyleProp = {
  maxWidth: 1,
  justifyContent: 'center',
  cursor: 'default',
  width: 490,
  minHeight: 224
};

const modalContentStyles: SxStyleProp = {
  position: 'relative',
  width: '100%',
  px: '32px',
  py: 6,
  bg: 'background',
  color: 'grey4',
  borderRadius: 'modal'
};

export const FilesAreUploadingModal: FC<FilesAreUploadingModalProps> = ({
  closeHandler,
  isOpen
}) => {
  const translator = useTranslator();
  return (
    <ModalBasic opened={isOpen} closeHandler={closeHandler}>
      <Flex sx={modalContainerStyles} data-test="files-uploading-notice">
        <Box sx={modalContentStyles}>
          <Flex>
            <Text sx={{ color: 'text', textAlign: 'left' }} variant="popupHeading">
              {translator('Notice')}
            </Text>
          </Flex>
          <Flex sx={{ flexDirection: 'column' }}>
            <Text mt={3} variant="modalBody">
              {translator(
                'Video–not_ready_to_download_yet._Please_wait_until_all_files_have_finished_loading.'
              )}
            </Text>
            <Button
              variant="primary"
              onClick={closeHandler}
              sx={{
                position: 'absolute',
                bottom: '32px',
                alignSelf: 'flex-end'
              }}
              date-testid="close"
            >
              {translator('Close')}
            </Button>
          </Flex>
        </Box>
      </Flex>
    </ModalBasic>
  );
};
